import { useEffect, useState } from 'react';
import type { FilterProps } from '../../Filters';

export const BrokerFilter = ({ filters: { is_private: isPrivateAsMaybeString }, onFilterChanged }: FilterProps) => {
    // isPrivateAsMaybeString == undefined is a valid case, so these checks need to be this specific
    const isPrivate = isPrivateAsMaybeString === true || isPrivateAsMaybeString === 'true';
    const isBusiness = isPrivateAsMaybeString === false || isPrivateAsMaybeString === 'false';

    const [brokerPrivate, setBrokerPrivate] = useState(isPrivate);
    const [brokerBusiness, setBrokerBusiness] = useState(isBusiness);

    useEffect(() => {
        // If both boxes are checked nothing should be done; otherwise both boxes will be unset
        if (isPrivateAsMaybeString !== undefined) {
            setBrokerPrivate(isPrivate);
            setBrokerBusiness(isBusiness);
        }
    }, [isPrivateAsMaybeString]);

    useEffect(() => {
        const filterValue = (brokerPrivate && brokerBusiness) || (!brokerPrivate && !brokerBusiness) ? undefined : brokerPrivate;

        // Only trigger if changed; otherwise there will be an eternal loop
        if (filterValue !== isPrivateAsMaybeString) {
            onFilterChanged({ is_private: filterValue });
        }
    }, [brokerPrivate, brokerBusiness]);

    return (
        <div data-testid="brokerFilter">
            <div className="input-toggle">
                <input
                    id="brokerPrivate"
                    type="checkbox"
                    checked={brokerPrivate}
                    value="brokerPrivate"
                    onChange={(event) => setBrokerPrivate(event.target.checked)}
                    data-testid="privateFilter"
                />
                <label htmlFor="brokerPrivate">
                    <span>Privat</span>
                </label>
            </div>
            <div className="input-toggle">
                <input
                    id="brokerBusiness"
                    type="checkbox"
                    checked={brokerBusiness}
                    value="brokerBusiness"
                    onChange={(event) => setBrokerBusiness(event.target.checked)}
                    data-testid="businessFilter"
                />
                <label htmlFor="brokerBusiness">
                    <span>Firma</span>
                </label>
            </div>
        </div>
    );
};
